import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=2538f20a&scoped=true&"
import script from "./Mailbox.vue?vue&type=script&lang=js&"
export * from "./Mailbox.vue?vue&type=script&lang=js&"
import style0 from "./Mailbox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Mailbox.vue?vue&type=style&index=1&id=2538f20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538f20a",
  null
  
)

export default component.exports